import request from '@/utils/request'

export function fetchWxSign(url) {
  return request({
    url: `/wx/sign?url=${encodeURIComponent(url)}`
  })
}

export function fetchWxPay(orderID) {
  return request({
    url: `/wx/pay/${orderID}`,
    method: 'get'
  })
}

export function fetchWxAuth(query) {
  return request({
    url: `/wx/auth`,
    method: 'get',
    params: query
  })
}

export function uploadLog(content) {
  return request({
    url: '/auth/msg',
    method: 'post',
    data: { msg: content }
  })
}



// WEBPACK FOOTER //
// ./src/api/wx.js